export const getCoahuilaData = () => ({
  name: "Coahuila",
  country: "Mexique",
  description: "Coahuila est une région viticole historique du nord du Mexique, célèbre pour la vallée de Parras de la Fuente, considérée comme le berceau du vin mexicain. Le climat semi-aride et l'altitude favorisent des vins de caractère.",
  type: "region",
  mapAreas: [
    { region: "Coahuila", x: 30, y: 50, color: "#6d2c7a", size: 3 }
  ],
  statistics: {
    totalArea: "800 ha",
    production: "0.05 million hectolitres",
    appellations: "Aucune (région libre)",
    subregions: "Parras de la Fuente",
    exportPercentage: "5%"
  },
  characteristics: {
    climate: "Climat semi-aride, altitude élevée, grandes amplitudes thermiques",
    soil: "Sols calcaires, argileux, bonne rétention d'eau",
    viticulture: "Viticulture traditionnelle et moderne, irrigation nécessaire"
  },
  wineStyles: {
    red: "Vins rouges puissants, souvent à base de Cabernet Sauvignon, Merlot, Shiraz",
    white: "Vins blancs frais et aromatiques (Chardonnay, Chenin Blanc)",
    rose: "Rosés fruités et vifs",
    sparkling: "Vins effervescents, production limitée"
  },
  history: "La vallée de Parras de la Fuente abrite la plus ancienne cave d'Amérique (Casa Madero, fondée en 1597). Coahuila a une longue tradition viticole, combinant histoire et innovation.",
  foodPairing: "Viandes grillées, agneau, plats épicés, fromages locaux.",
  subregions: {
    "parras-de-la-fuente": {
      name: "Parras de la Fuente",
      description: "Berceau du vin mexicain, réputé pour ses rouges puissants et ses blancs aromatiques.",
      characteristics: {
        climate: "Semi-aride, altitude élevée",
        soil: "Sols calcaires et argileux",
        viticulture: "Vignobles historiques et modernes"
      },
      grapeVarieties: {
        red: ["Cabernet Sauvignon", "Merlot", "Shiraz"],
        white: ["Chardonnay", "Chenin Blanc"]
      },
      wineStyles: {
        "rouge": "Rouges puissants et structurés",
        "blanc": "Blancs frais et aromatiques"
      },
      foodPairing: "Viandes rouges, fromages, cuisine mexicaine épicée"
    }
  }
}); 